import * as React from 'react';
import { WorkOrder } from '../../Common/Services/WorkOrder';
import { IWorkOrderCommentRequestDto } from '../../Common/Contracts/IWorkOrder';
import { Utils } from '../../Common/Utilis';
import "./workOrderDetails.scss";
import { resolve, reject } from "q";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { Spinner } from "react-bootstrap";

export default class AddHistoryBox extends React.Component<any, any> {
    private scrollToBottomlist: any;
  constructor(props: any) {
    super(props);
    // this.scrollToBottomlist = React.createRef();
        this.state = {
            hotelid: this.props.hotelid,
            entryType: this.props.entryType,
            workOrderId: this.props.workOrderId,            
          // precommentlist: this.props.precommentlist,
           precommentlist:[],
            value: '',
            mentionData: null,
            commentlist: [],
            users: [],
            htmlHistory: [],
            userComments: [],
            logInUser: "",
            logInUserImage: "",
            isCommentAdd: false,
            addCommentDisabled : this.props.addCommentDisabled,
            workOrderName : this.props.parentState.parentRowData.name,
            allHistoryData: [], // Store all history data
            visibleHistoryData: [], // Paginated history data
            initialLoadLimit: 10, // Initial records to load
            nextLoadLimit: 30, // Next records to load
            currentLimit: 0,
            isLoading: false,
  };
  }

  
  reloadHistory = () => {
    this.setState({ currentLimit: 0 });
    this.getHistoryWorkOrder();
  }

  componentDidMount() {
    this.getHistoryWorkOrder();
  }

  checkScrollPosition = () => {
    if (this.scrollToBottomlist) {
      const { scrollTop, scrollHeight, clientHeight } = this.scrollToBottomlist;
  
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        this.loadMoreData();
      }
    }
  };

  loadMoreData = () => {
    if (this.state.isLoading || this.state.visibleHistoryData.length >= this.state.allHistoryData.length) {
      return;
    }

    this.setState({ isLoading: true });

    setTimeout(() => {
      const { allHistoryData, visibleHistoryData, currentLimit, nextLoadLimit, initialLoadLimit } = this.state;
      const newLimit = currentLimit === 0 ? initialLoadLimit : currentLimit + nextLoadLimit;

      const nextRecords = allHistoryData.slice(visibleHistoryData.length, newLimit);

      if (nextRecords.length > 0) {
        this.setState((prevState) => ({
          visibleHistoryData: [...prevState.visibleHistoryData, ...nextRecords],
          currentLimit: newLimit,
          isLoading: false,
        }));
      } else {
        this.setState({ isLoading: false });
      }
    }, 500);
  };

    getHistoryWorkOrder()
    {
        let request = {} as IWorkOrderCommentRequestDto;
        request.hotelid =  Number(this.state.hotelid);
        request.workOrderID =Number(this.state.workOrderId);
        this.setState({ allHistoryData: [], visibleHistoryData: [], isLoading: false });
        WorkOrder.getHistoryWorkOrder(request)
          .then(async (result: any | null) => {          
            if (result != null && result.length > 0) {
              this.setState({ allHistoryData: result, isLoading: false }, () => {
                this.checkScrollPosition(); // Load initial records
              });
            } else {
              this.setState({ allHistoryData: [], visibleHistoryData: [], isLoading: false });
            }
           
          
            resolve();
          })
          .catch((err) => {
            this.setState({ isLoading: false });
            Utils.toastError(`Server Error, ${err}`, {
            });
    
            reject();
          });
    }
    getBadgeClass(value) {
      switch (value) {
          case "Open": return "badge open";
          case "In Progress": return "badge progress-badge";
          case "On Hold": return "badge hold-badge";
          case "Completed": return "badge completed";
          default: return "badge";
      }
  }
    loadPrevHistory() {
      const { precommentlist } = this.state;
    
      if (precommentlist.length > 0) {
        const itemComment = precommentlist.map((element,index) => {
          let message = "";
          switch (element.columnName) {
            case "CreateWorkOrder":
              message = `${element.createBy} created Work Order <b>${element.oldValue}</b>`;
              break;
            case "Title":
              message = `${element.createBy} changed Work Order name from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
              break;
            case "Status":
              const oldClass = this.getBadgeClass(element.oldValue);
              // const newClass = this.getBadgeClass(element.newValue);
              const newClassValue = element.newValue?.split(":")[0] || "";
              const badgeNewValue=this.getBadgeClass(newClassValue);
              const additionalText = element.newValue?.split(":")[1]?.trim() ? `: ` : "";
              const additionalTextValue = element.newValue?.split(":")[1]?.trim() ? ` ${element.newValue.split(":")[1]?.trim()}` : "";
              const additionalNotes = element.additionalNotes ? ` - ${element.additionalNotes}` : "";
              // message = `${element.createBy} changed Work Order Status from <span class="${oldClass}">${element.oldValue || "None"}</span> to <span class="${newClass}">${element.newValue || "None"}</span>`;
              message = `${element.createBy} changed Work Order Status from <span class="${oldClass}">${element.oldValue || "None"}</span> to <span class="${badgeNewValue}">${newClassValue || "None"}</span> ${additionalText} <br /><strong>${additionalTextValue}</strong> ${additionalNotes}`;
              break;
            case "AssignedTo":
              message = `${element.createBy} reassigned Work Order from <b>${element.oldValue}</b> to <b>${element.newValue}</b>`;
              break;
            case "Description":
              message = `${element.createBy} updated Description from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
              break;
            case "Location":
              message = `${element.createBy} changed Location of Work Order from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
              break;
            case "PriorityType":
              message = `${element.createBy} changed Priority from <b class="priority ${element.oldValue.toLowerCase()}">${element.oldValue || "None"}</b> to <b class="priority ${element.newValue.toLowerCase()}">${element.newValue || "None"}</b>`;
              break;
              case "FileAdd":
              message = `${element.createBy} attached <b>${element.oldValue}</b>`;
              break;
              case "FileDelete":
              message = `${element.createBy} removed <b>${element.oldValue}</b>`;
              break;
              case "Comments":
              message = `${element.createBy} added a comment to ${this.state.workOrderName} : <b>${element.oldValue}</b>`;
              break;
              case "AssetRemoved":
                let IsRemovemultiPly=element.oldValue.split(',');
                message = IsRemovemultiPly.length>1 ?`${element.createBy} removed Assets: <b>${element.oldValue}</b>`:`${element.createBy} removed Asset: <b>${element.oldValue}</b>`;
                break;
                case "AssetAdded":
                  let IsmultiPly=element.oldValue.split(',');
                  message = IsmultiPly.length>1 ?`${element.createBy} added Assets: <b>${element.oldValue}</b>` :`${element.createBy} added Asset: <b>${element.oldValue}</b>` ;
                  break;
              case "AssetLocationchange":
                message = `${element.createBy} changed Location of Asset <b>${element.additionalNotes || "None"}</b> from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
                break;
            default:
              message = `${element.createBy} changed ${element.columnName} from  <b> ${element.oldValue || "None"}</b> to <b> ${element.newValue || "None"}</b>`;
              break;
          }
          return (
            <div key={element.ordered} className="timeline-item">
              <div className="timeline-dot"></div>
              {index !== precommentlist.length - 1 && <div className="timeline-line"></div>}
              <div className="timeline-content">
                <span className="timeline-date">{element.modifyedDate}</span>
                <div className="timeline-message" dangerouslySetInnerHTML={{ __html: message }}></div>
              </div>
            </div>
          );
        });
        this.setState({ htmlHistory: itemComment });
      }
    }

  render() {
    return (
      <div className="comment-box" ref={(ref) => (this.scrollToBottomlist = ref)}>
        <div className="comment-list">
          <ul>
            {this.state.visibleHistoryData.map((element, index) => {
              let message = "";
              switch (element.columnName) {
                case "CreateWorkOrder":
                  message = `${element.createBy} created Work Order <b>${element.oldValue}</b>`;
                  break;
                case "Title":
                  message = `${element.createBy} changed Work Order name from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
                  break;
                case "Status":
                  const oldClass = this.getBadgeClass(element.oldValue);
                  // const newClass = this.getBadgeClass(element.newValue);
                  const newClassValue = element.newValue?.split(":")[0] || "";
                  const badgeNewValue=this.getBadgeClass(newClassValue);
                  const additionalText = element.newValue?.split(":")[1]?.trim() ? `: ` : "";
                  const additionalTextValue = element.newValue?.split(":")[1]?.trim() ? ` ${element.newValue.split(":")[1]?.trim()}` : "";
                  const additionalNotes = element.additionalNotes ? ` - ${element.additionalNotes}` : "";
                  // message = `${element.createBy} changed Work Order Status from <span class="${oldClass}">${element.oldValue || "None"}</span> to <span class="${newClass}">${element.newValue || "None"}</span>`;
                  message = `${element.createBy} changed Work Order Status from <span class="${oldClass}">${element.oldValue || "None"}</span> to <span class="${badgeNewValue}">${newClassValue || "None"}</span> ${additionalText} <br /><strong>${additionalTextValue}</strong> ${additionalNotes}`;
                  break;
                case "AssignedTo":
                  message = `${element.createBy} reassigned Work Order from <b>${element.oldValue}</b> to <b>${element.newValue}</b>`;
                  break;
                case "Description":
                  message = `${element.createBy} updated Description from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
                  break;
                case "Location":
                  message = `${element.createBy} changed Location of Work Order from <b>${element.oldValue || "None"}</b> to <b>${element.newValue || "None"}</b>`;
                  break;
                case "PriorityType":
                  message = `${element.createBy} changed Priority from <b class="priority ${element.oldValue.toLowerCase()}">${element.oldValue || "None"}</b> to <b class="priority ${element.newValue.toLowerCase()}">${element.newValue || "None"}</b>`;
                  break;
                  case "FileAdd":
                  message = `${element.createBy} attached <b>${element.oldValue}</b>`;
                  break;
                  case "FileDelete":
                  message = `${element.createBy} removed <b>${element.oldValue}</b>`;
                  break;
                  case "Comments":
                  message = `${element.createBy} added a comment to ${this.state.workOrderName} : <b>${element.oldValue}</b>`;
                  break;
                  case "AssetRemoved":
                    let IsRemovemultiPly=element.oldValue.split(',');
                    message = IsRemovemultiPly.length>1 ?`${element.createBy} removed Assets: <b>${element.oldValue}</b>`:`${element.createBy} removed Asset: <b>${element.oldValue}</b>`;
                    break;
                    case "AssetAdded":
                      let IsmultiPly=element.oldValue.split(',');
                      message = IsmultiPly.length>1 ?`${element.createBy} added Assets: <b>${element.oldValue}</b>` :`${element.createBy} added Asset: <b>${element.oldValue}</b>` ;
                      break;
                default:
                  message = `${element.createBy} changed ${element.columnName} from  <b> ${element.oldValue || "None"}</b> to <b> ${element.newValue || "None"}</b>`;
                  break;
              }

              const isLast = index === this.state.visibleHistoryData.length - 1;
              return (
                <div key={element.ordered} className="timeline-item">
                  <div className="timeline-dot"></div>
                  {!isLast && <div className="timeline-line"></div>}
                  <div className="timeline-content">
                    <span className="timeline-date">{element.modifyedDate}</span>
                    <div className="timeline-message" dangerouslySetInnerHTML={{ __html: message }}></div>
                  </div>
                </div>
              );
            })}
          </ul>
        </div>

        {this.state.isLoading && (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" size="sm" variant="secondary" />
          </div>
        )}
      </div>
    );
  }
}
